module.exports = __webpack_public_path__ + "static/media/sp31.1320563b.JPG";